import {type UIChild, UI} from "stem-core/ui/UIBase";
import {styleRule, registerStyle, StyleSheet} from "stem-core/ui/Style";
import {Input} from "../../stem-core/ui/input/Input";
import {MakeInfoElement} from "./InfoTooltip";

export class BlinkInputFieldStyle extends StyleSheet {
    @styleRule
    container = {
        display: "inline-block",
        margin: 8,
        " input": {
            height: 36,
        },
        " input[disabled]": {
            color: "#AAA",
        },
        " select": {
            height: 36,
        },
    }

    @styleRule
    inputFieldLabel = {
        display: "inline-block",
        fontSize: 12,
        fontWeight: 700,
        padding: 4,
    }

    @styleRule
    inputFieldHelp = {
        display: "inline-block",
    }
}

interface BlinkInputFieldOptions {
    onChange?: (...args: any[]) => void;
    label?: UIChild;
    // Rendered as the little tooltip beside the label
    helpInfo?: UIChild;
}

@registerStyle(BlinkInputFieldStyle)
export class BlinkInputField<ExtraOptions = {}> extends UI.Element<BlinkInputFieldOptions & ExtraOptions> {
    render() {
        const {styleSheet} = this;
        const {label, helpInfo} = this.options;

        return [
            <div>
                <span className={styleSheet.inputFieldLabel}>{label}</span>
                {MakeInfoElement(helpInfo)}
            </div>,
            ...(this.getGivenChildren() as UIChild[]),
        ];
    }
}

// TODO implement like GMail and move to another file
// A text input read as a list, so it builds on Input's value type the way NumberInput does
export class MultiEmailAddressInput extends Input<string[]> {
    getInputType() {
        return "text";
    }

    getValue() {
        const str = this.getRawValue().trim();
        return str.split(",").map(emailAddress => emailAddress.trim()).filter(emailAddress => emailAddress.length > 0);
    }

    setValue(emails: string[]) {
        const str = (emails || []).join(",");
        super.setValue(str);
    }
}
